<template>
  <div class="wrapper blog-post">
    <div class="page-header page-header-small">
      <parallax class="page-header-image" style="background-image: url('img/bg24.jpg')"></parallax>
      <div class="content-center">
        <div class="row">
          <div class="col-md-8 ml-auto mr-auto text-center">
            <h2 class="title">Trámites</h2>
            <h4>¿Sabías que podés realizar tus trámites online?</h4>
          </div>
        </div>
      </div>
    </div>
    <div class="main">
      <tramites-detalle></tramites-detalle>
    </div>
  </div>
</template>
<script>
import {
  Card,
  Button,
  Comment,
  Badge,
  InfoSection,
  Checkbox
} from "@/components";
import TramitesDetalle from "./cmsComponents/TramitesDetalle";

export default {
  name: "blog-post",
  bodyClass: "blog-post",
  components: {
    Card,
    TramitesDetalle
  },
  data() {
    return {};
  }
};
</script>
<style>
</style>
